import i18n from '@/utils/i18n';
import React, { useMemo } from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { List } from '@/components/list';
import { ListDisplayMode } from '@/enums';
import { ListOption } from '@/components/list-item';
import { RadioButton } from '@/components/radio-button';
import { SCREEN_PADDING, TYPOGRAPHY } from '@/styles';
import { StyleSheet, Text, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

type DisplayModeOption = ListOption<{ isSelected: boolean }> & {
  value: ListDisplayMode;
};

interface Props {
  buttonRef?: React.RefObject<View | null>;
  isVisible: boolean;
  onChange: (mode: ListDisplayMode) => void;
  onClose: () => void;
  value: ListDisplayMode;
}

export const DisplayModeActionSheet: React.FC<Props> = ({
  buttonRef,
  isVisible,
  onChange,
  onClose,
  value,
}) => {
  const { isSmallLayout } = useLayoutContext();

  const displayModeOptions = useMemo<DisplayModeOption[]>(() => {
    return [
      {
        metadata: {
          isSelected: value === ListDisplayMode.List,
        },
        title: i18n.t('catalog_display_list'),
        value: ListDisplayMode.List,
      },
      {
        metadata: {
          isSelected: value === ListDisplayMode.Grid,
        },
        title: i18n.t('catalog_display_grid'),
        value: ListDisplayMode.Grid,
      },
    ];
  }, [value]);

  return (
    <BaseActionSheet
      contentStyle={styles.actionSheet}
      isVisible={isVisible}
      onClose={onClose}
      popoverTarget={buttonRef?.current}
    >
      {isSmallLayout ? (
        <Text style={[TYPOGRAPHY.h2, styles.title]}>
          {i18n.t('catalog_display')}
        </Text>
      ) : null}
      <List<DisplayModeOption>
        data={displayModeOptions}
        onSelect={(option) => {
          onChange(option.value);
          onClose();
        }}
        renderRightComponent={(option) => {
          return (
            <RadioButton selected={Boolean(option.metadata?.isSelected)} />
          );
        }}
      />
    </BaseActionSheet>
  );
};

const styles = StyleSheet.create({
  actionSheet: {
    paddingHorizontal: 0,
  },
  title: {
    paddingBottom: 8,
    paddingHorizontal: SCREEN_PADDING,
  },
});
